<script setup lang="ts">
withDefaults(defineProps<{
  single: string,
  multi: string,
  value: number
}>(), {
  value: 0
});
</script>

<template>
  <span v-if="value===1">
    {{ single }}
  </span>
  <span v-else>
    {{ multi }}
  </span>
</template>

<style scoped lang="scss">

</style>